import { TextArea } from "shared/components/forms/TextArea";

export const LongTextWidget = () => {
  return (
    <TextArea
      placeholder="Type your answer here"
      disabled
      legacyErrorMargins={false}
      id="long-text"
      rows={4}
    />
  );
};
